module.exports = __webpack_public_path__ + "static/media/react@3x.e7b4daed.png";